import { ChannelType } from './types';

export const REMOVE_NAME_FIELDS_TEST_NAME = 'provider_signup_remove_name_fields_102820';
export const REMOVE_NAME_FIELDS_TEST_PERCENT = 0.5;

export const SIGNUP_MARKETING_TEST_FLAG = 'pro_signup_marketing_ev3044_20201105';
export const SIGNUP_MARKETING_TEST_PERCENT = 0.5;

export const SIGNUP_CHANNEL_TEST_FLAG = 'provider_signup_signup_channel_111820';
export const SIGNUP_CHANNEL_TEST_PERCENT = 0.1;

export const CHANNEL_OPTIONS = [
  ChannelType.REFERRED_BY_PRO,
  ChannelType.REFERRED_BY_CLIENT,
  ChannelType.INSTAGRAM,
  ChannelType.FACEBOOK,
  ChannelType.PINTEREST,
  ChannelType.GOOGLE,
  ChannelType.APP_STORE,
];
